/**
 * @ngdoc directive
 * @name BB.bbTotal
 * @restrict AE
 * @scope true
 *
 * @description
 * Directive used to proceed with payment done (PayPal etc.) and specify status of the total purchase.
 */
angular.module('BBPublicBooking').directive('bbTotal', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        controller: 'Total'
    };
});



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/total/bb_total.directive.js